const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * TextSearch Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('TextSearch', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/text-search/:subresource', null, {
    smartSearch: {params: {subresource: 'smart-search'}, method: 'GET', isArray: false},
    contentPage: {params: {subresource: 'content'}, method: 'GET', isArray: false}
  });

}]);